export const InstructorsSymbols = {
    InstructorsService: Symbol.for("InstructorsService"),
    InstructorsProvider: Symbol.for("InstructorsProvider")
}